import Axios from "axios";
import {store} from '../../store/';

export const Filter = {
  saveFilterSettings(data) {
    return Axios.patch(`/hospitals/${store.state.user.active_user.ref}/filter_settings/${data.id}`, {filter_setting: data})
  },
};